import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

function NotFound() {
  return (
    <div className="not-found-page">
      <span className="not-found-wordmark">around</span>
      <div className="empty-state-icon"><Icon name="flag" size={24} /></div>
      <p className="eyebrow">404</p>
      <h1 className="not-found-title">Out of bounds.</h1>
      <p className="not-found-text">That page doesn't exist. Take a drop and head back.</p>
      <Link to="/" className="btn btn-primary">Back to around</Link>
    </div>
  );
}

export default NotFound;
